import { Button, Drawer, message } from "antd";
import Input from "../../Components/CommonCommponents/Input";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Womanwithlaptop from "../../Assets/Icons/GroupLaptop.png";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import { Alert } from "antd";
import toast from "react-hot-toast";

const ForgetPassword = ({ onClose }) => {
  const location = useLocation();
  console.log("location", location.pathname.includes("jobDetails"));
  const navigate = useNavigate();

  const {
    register,
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data, "data");
    await AuthService.ForgetPassword(data)
      .then(
        (oResponse) => {
          toast.success("Please Check Your Mail");
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        toast.error("Failed To Reset");
      });
  };
  console.log(errors,"errors");
  return (
    <div>
      {errors?.non_field_errors?.message && (
        <Alert
          message="Whoops !"
          type="error"
          description={errors?.non_field_errors?.message}
          style={{ width: "100%", margin: "auto" }}
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-10">
          <div className="w-full">
            <Input
              name="email_or_mobile_number"
              label=""
              control={control}
              placeholder="Enter Email ID"
              rules={{
                required: "This field is required",
              }}
              className="h-12"
            />
          </div>
        </div>
        <div className="mt-10">
          <button
            className="bg-[#FF4544] text-white w-full rounded-md h-[42px]"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};
export default ForgetPassword;
